/**
 * Helpers for the "Generate labels with AI" flow used by the upload modal.
 *
 * Two row shapes coexist in `aiLabels`:
 *   - generated rows  (`isNew: false`) — name comes from the LLM, user may
 *     remap it to an existing project label via `replaceWith`.
 *   - new-label rows  (`isNew: true`)  — user-typed label, no remap.
 */

/**
 * Build a stable empty new-label row.
 *
 * @param {number} index - Position used for id disambiguation.
 * @returns {{ id: string, name: string, replaceWith: null, isNew: true }}
 */
export const makeEmptyAiLabelRow = (index = 0) => ({
    id: `ai_label_${Date.now()}_${index}`,
    name: '',
    replaceWith: null,
    isNew: true,
});

/**
 * Convert an `aiLabels` row list into the `{ extracted: target }` mapping the
 * upload modal submits as `label_mappings`.
 *
 * @param {Array<{ name?: string, replaceWith?: string|null, isNew?: boolean }>} rows
 * @returns {Object<string, string>}
 */
export const aiLabelRowsToMapping = (rows) => {
    const mapping = {};
    (rows || []).forEach((row) => {
        const raw = (row?.name || '').trim();
        if (!raw) return;
        const mapped = (row?.isNew ? raw : (row?.replaceWith || '')).trim();
        mapping[raw] = mapped || raw;
    });
    return mapping;
};
